import React, { useMemo, useState } from 'react';

const SOURCE_COLORS = {
  template: 'attribution-pill--template',
  practice_a: 'attribution-pill--practice-a',
  practice_b: 'attribution-pill--practice-b',
};

const SOURCE_LABELS = {
  template: 'Template',
  practice_a: 'Practice A',
  practice_b: 'Practice B',
};

const normalize = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/^[\d\W_]+/, '')
    .replace(/\s+/g, ' ')
    .trim();

const SourceAttribution = ({ sectionAttribution }) => {
  const [open, setOpen] = useState({});
  const sections = useMemo(() => {
    if (!sectionAttribution || typeof sectionAttribution !== 'object') {
      return [];
    }
    return Array.isArray(sectionAttribution.sections)
      ? sectionAttribution.sections.filter((item) => item && item.heading)
      : [];
  }, [sectionAttribution]);

  const omittedContent = Array.isArray(sectionAttribution?.omitted_content)
    ? sectionAttribution.omitted_content
    : [];

  if (!sections.length && !omittedContent.length) {
    return null;
  }

  return (
    <section className="source-attribution panel panel--spaced">
      <div className="source-attribution__header">
        <h3>Source Attribution</h3>
        <div className="source-attribution__legend">
          {Object.entries(SOURCE_LABELS).map(([key, label]) => (
            <span key={key} className={`attribution-pill ${SOURCE_COLORS[key]}`}>
              {label}
            </span>
          ))}
        </div>
      </div>

      {sections.length > 0 && (
        <div className="source-attribution__sections">
          {sections.map((section, idx) => {
            const sectionId = `attribution-${idx}`;
            const detailOpen = Boolean(open[sectionId]);
            const sources = Array.isArray(section.sources) ? section.sources : [];
            return (
              <article key={`${section.heading}-${idx}`} className="source-attribution__item">
                <div className="source-attribution__item-head">
                  <h4>{section.heading}</h4>
                  <div className="source-attribution__badges">
                    {sources.map((source) => (
                      <span key={source} className={`attribution-pill ${SOURCE_COLORS[source] || ''}`}>
                        {SOURCE_LABELS[source] || normalize(source)}
                      </span>
                    ))}
                  </div>
                </div>
                <button
                  className="section-toggle"
                  onClick={() => setOpen({ ...open, [sectionId]: !detailOpen })}
                  aria-expanded={detailOpen}
                  aria-controls={sectionId}
                >
                  {detailOpen ? 'Hide Source Detail' : 'Show Source Detail'}
                </button>
                {detailOpen && (
                  <div id={sectionId}>
                    <p className="muted">{section.source_detail || 'No source detail provided.'}</p>
                    <p className="muted">Section word count: {section.word_count || 'N/A'}</p>
                  </div>
                )}
              </article>
            );
          })}
        </div>
      )}

      {omittedContent.length > 0 && (
        <div className="source-attribution__omitted">
          <h4>Omitted Content</h4>
          <ul className="insight-list">
            {omittedContent.map((item, idx) => (
              <li key={`${item.source || 'source'}-${idx}`}>
                <strong>{SOURCE_LABELS[item.source] || item.source || 'Source'}:</strong>{' '}
                {item.description || 'Omitted section'} ({item.reason || 'No reason provided'})
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default SourceAttribution;
